// Generated by scripts/gen_bereich_stats.py from
// reference/bereich-varieties.csv and reference/bereich-notes.csv
// (Statistische Landesämter planting statistics). Per-bereich variety
// shares, totals and prose notes, plus per-region aggregates for the
// sidebar statistics sections. pct = % of the bereich/region planted area.
export const BEREICH_STATS = {
  "Ahr": {
    "Walporzheim/Ahrtal": {
      "totalHa": 531.0,
      "year": 2023,
      "complete": true,
      "notes": "Spätburgunder covers 64.4% of plantings and Frühburgunder a further 5.9%, giving a red share of 79.5%, the highest of any German Bereich. The Ahr holds 17.8% of all German Frühburgunder on 31 hectares. Riesling remains at 8.7%.",
      "varieties": [
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 342.0,
          "pct": 64.4
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 46.0,
          "pct": 8.7
        },
        {
          "name": "Frühburgunder",
          "color": "red",
          "ha": 31.0,
          "pct": 5.9
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 22.0,
          "pct": 4.2
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 22.0,
          "pct": 4.1
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 15.0,
          "pct": 2.9
        },
        {
          "name": "Regent",
          "color": "red",
          "ha": 15.0,
          "pct": 2.7
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 14.0,
          "pct": 2.6
        },
        {
          "name": "Portugieser",
          "color": "red",
          "ha": 12.0,
          "pct": 2.3
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 12.0,
          "pct": 2.2
        }
      ]
    }
  },
  "Baden": {
    "Badische Bergstraße": {
      "totalHa": 381.0,
      "year": 2024,
      "complete": false,
      "notes": "Baden's smallest Bereich at 381 hectares, on the same hillside as the Hessische Bergstraße but in a different Anbaugebiet. Riesling covers 17.6%, second in Baden only to the Ortenau. It is one of the two Baden Bereiche where VDP permits Lemberger for Grosses Gewächs.",
      "varieties": [
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 107.0,
          "pct": 28.1
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 67.0,
          "pct": 17.6
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 47.0,
          "pct": 12.3
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 44.0,
          "pct": 11.5
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 41.0,
          "pct": 10.8
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 3.0,
          "pct": 0.8
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 1.0,
          "pct": 0.3
        },
        {
          "name": "Trollinger",
          "color": "red",
          "ha": 1.0,
          "pct": 0.3
        }
      ]
    },
    "Bodensee": {
      "totalHa": 668.0,
      "year": 2024,
      "complete": false,
      "notes": "Müller-Thurgau covers 24.3%, the highest share of any Baden Bereich, reflecting the cool, high site moderated by the lake. Spätburgunder leads at 34.6% and is often vinified pale as Weissherbst. Riesling covers 1.3%.",
      "varieties": [
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 231.0,
          "pct": 34.6
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 162.0,
          "pct": 24.3
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 80.0,
          "pct": 12.0
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 56.0,
          "pct": 8.4
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 9.0,
          "pct": 1.3
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 7.0,
          "pct": 1.0
        },
        {
          "name": "Gutedel",
          "color": "white",
          "ha": 5.0,
          "pct": 0.7
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 2.0,
          "pct": 0.3
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 1.0,
          "pct": 0.1
        }
      ]
    },
    "Breisgau": {
      "totalHa": 1544.0,
      "year": 2024,
      "complete": false,
      "notes": "Spätburgunder leads at 36.3%. The three Burgunder varieties and Müller-Thurgau together account for more than 80% of the reported area. Riesling covers 1.7%.",
      "varieties": [
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 561.0,
          "pct": 36.3
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 259.0,
          "pct": 16.8
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 256.0,
          "pct": 16.6
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 213.0,
          "pct": 13.8
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 26.0,
          "pct": 1.7
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 5.0,
          "pct": 0.3
        },
        {
          "name": "Gutedel",
          "color": "white",
          "ha": 3.0,
          "pct": 0.2
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 1.0,
          "pct": 0.1
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 2.0,
          "pct": 0.1
        }
      ]
    },
    "Kaiserstuhl": {
      "totalHa": 4163.0,
      "year": 2024,
      "complete": false,
      "notes": "Spätburgunder (31.3%) and Grauburgunder (25.6%) together take more than half the Bereich, and its 1,067 hectares of Grauburgunder is the largest concentration in Germany. Riesling covers 0.8%. Müller-Thurgau remains a large third variety at 685 hectares. Soils are volcanic, from the extinct Kaiserstuhl volcano.",
      "varieties": [
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 1303.0,
          "pct": 31.3
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 1067.0,
          "pct": 25.6
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 685.0,
          "pct": 16.5
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 564.0,
          "pct": 13.5
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 35.0,
          "pct": 0.8
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 1.0,
          "pct": 0.0
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 1.0,
          "pct": 0.0
        }
      ]
    },
    "Kraichgau": {
      "totalHa": 1174.0,
      "year": 2024,
      "complete": false,
      "notes": "One of only two Baden Bereiche with meaningful Lemberger (64 ha) and Trollinger (20 ha), and consequently one of the two where VDP permits Lemberger for Grosses Gewächs. Riesling at 12.8% is high for Baden. Schwarzriesling covers 66 hectares.",
      "varieties": [
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 241.0,
          "pct": 20.5
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 185.0,
          "pct": 15.8
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 161.0,
          "pct": 13.7
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 150.0,
          "pct": 12.8
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 87.0,
          "pct": 7.4
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 66.0,
          "pct": 5.6
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 64.0,
          "pct": 5.5
        },
        {
          "name": "Trollinger",
          "color": "red",
          "ha": 20.0,
          "pct": 1.7
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 1.0,
          "pct": 0.1
        }
      ]
    },
    "Markgräflerland": {
      "totalHa": 3273.0,
      "year": 2024,
      "complete": false,
      "notes": "Gutedel covers 991 hectares, 30.3%, and accounts for essentially all of Germany's roughly 1,000 hectares of the variety, known as Chasselas across the Swiss border. Spätburgunder follows at 26.3%. Riesling covers 0.5%.",
      "varieties": [
        {
          "name": "Gutedel",
          "color": "white",
          "ha": 991.0,
          "pct": 30.3
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 861.0,
          "pct": 26.3
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 337.0,
          "pct": 10.3
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 277.0,
          "pct": 8.5
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 269.0,
          "pct": 8.2
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 18.0,
          "pct": 0.5
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 11.0,
          "pct": 0.3
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 1.0,
          "pct": 0.0
        }
      ]
    },
    "Ortenau": {
      "totalHa": 2593.0,
      "year": 2024,
      "complete": false,
      "notes": "Riesling covers 507 hectares, 19.6%, more than every other Baden Bereich combined; the local name is Klingelberger. Spätburgunder leads at 41.5%, the highest red share in Baden.",
      "varieties": [
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 1076.0,
          "pct": 41.5
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 507.0,
          "pct": 19.6
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 284.0,
          "pct": 11.0
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 262.0,
          "pct": 10.1
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 111.0,
          "pct": 4.3
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 3.0,
          "pct": 0.1
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 2.0,
          "pct": 0.1
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 1.0,
          "pct": 0.0
        }
      ]
    },
    "Tauberfranken": {
      "totalHa": 609.0,
      "year": 2024,
      "complete": false,
      "notes": "Müller-Thurgau leads at 23.3% and Schwarzriesling covers 18.2%, the highest share of any Baden Bereich. Spätburgunder reaches only 6.2%, the lowest in Baden. The Bereich lies on Muschelkalk in the Tauber valley and bottles in the Bocksbeutel.",
      "varieties": [
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 142.0,
          "pct": 23.3
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 111.0,
          "pct": 18.2
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 45.0,
          "pct": 7.4
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 38.0,
          "pct": 6.2
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 35.0,
          "pct": 5.7
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 20.0,
          "pct": 3.3
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 19.0,
          "pct": 3.1
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 1.0,
          "pct": 0.2
        }
      ]
    },
    "Tuniberg": {
      "totalHa": 1051.0,
      "year": 2024,
      "complete": false,
      "notes": "Spätburgunder covers 46.8%, the highest share of any German Bereich, and red area exceeds white among the reported varieties. Riesling covers 3 hectares. The Bereich is a limestone ridge adjoining the volcanic Kaiserstuhl.",
      "varieties": [
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 492.0,
          "pct": 46.8
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 169.0,
          "pct": 16.1
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 154.0,
          "pct": 14.7
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 134.0,
          "pct": 12.7
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 3.0,
          "pct": 0.3
        }
      ]
    }
  },
  "Mittelrhein": {
    "Loreley": {
      "totalHa": 439.0,
      "year": 2023,
      "complete": true,
      "notes": "Riesling covers 64.7% of the Bereich. Total area is 439 hectares, down 20.4% since 1999, the steepest proportional loss among German Bereiche. Spätburgunder is the second variety at 11% and has grown while the total has shrunk.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 284.0,
          "pct": 64.7
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 48.0,
          "pct": 11.0
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 29.0,
          "pct": 6.6
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 23.0,
          "pct": 5.2
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 21.0,
          "pct": 4.8
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 18.0,
          "pct": 4.2
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 16.0,
          "pct": 3.6
        }
      ]
    }
  },
  "Mosel": {
    "Bernkastel": {
      "totalHa": 5582.0,
      "year": 2023,
      "complete": true,
      "notes": "At 5,582 hectares the Bereich holds two thirds of the Mosel Anbaugebiet. Riesling covers 3,830 hectares, 68.6%, more Riesling than the entire Nahe or Rheingau. Müller-Thurgau remains the second variety at 559 hectares, 10%, and has been declining steadily since 1999.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 3830.0,
          "pct": 68.6
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 559.0,
          "pct": 10.0
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 269.0,
          "pct": 4.8
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 197.0,
          "pct": 3.5
        },
        {
          "name": "Dornfelder",
          "color": "red",
          "ha": 164.0,
          "pct": 2.9
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 118.0,
          "pct": 2.1
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 93.0,
          "pct": 1.7
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 92.0,
          "pct": 1.6
        },
        {
          "name": "Chardonnay",
          "color": "white",
          "ha": 59.0,
          "pct": 1.1
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 57.0,
          "pct": 1.0
        },
        {
          "name": "Bacchus",
          "color": "white",
          "ha": 41.0,
          "pct": 0.7
        },
        {
          "name": "Sauvignon blanc",
          "color": "white",
          "ha": 35.0,
          "pct": 0.6
        },
        {
          "name": "Regent",
          "color": "red",
          "ha": 30.0,
          "pct": 0.5
        },
        {
          "name": "Gewürztraminer",
          "color": "white",
          "ha": 15.0,
          "pct": 0.3
        },
        {
          "name": "Souvignier gris",
          "color": "white",
          "ha": 13.0,
          "pct": 0.2
        },
        {
          "name": "Roter Riesling",
          "color": "white",
          "ha": 12.0,
          "pct": 0.2
        }
      ]
    },
    "Burg Cochem": {
      "totalHa": 1110.0,
      "year": 2023,
      "complete": true,
      "notes": "The Terrassenmosel Bereich. Reds reach 15.3%, the highest in the Mosel, led by Spätburgunder (86 ha) and Dornfelder (57 ha). Plantings have fallen 37.5% since 1999, the steepest decline of any Bereich in Rheinland-Pfalz. Riesling still leads at 59.5%.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 660.0,
          "pct": 59.5
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 100.0,
          "pct": 9.0
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 86.0,
          "pct": 7.8
        },
        {
          "name": "Dornfelder",
          "color": "red",
          "ha": 57.0,
          "pct": 5.1
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 55.0,
          "pct": 5.0
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 50.0,
          "pct": 4.5
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 25.0,
          "pct": 2.3
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 22.0,
          "pct": 2.0
        },
        {
          "name": "Elbling",
          "color": "white",
          "ha": 15.0,
          "pct": 1.4
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 14.0,
          "pct": 1.3
        },
        {
          "name": "Chardonnay",
          "color": "white",
          "ha": 13.0,
          "pct": 1.2
        },
        {
          "name": "Regent",
          "color": "red",
          "ha": 12.0,
          "pct": 1.1
        }
      ]
    },
    "Moseltor": {
      "totalHa": 116.0,
      "year": 2020,
      "complete": false,
      "notes": null,
      "varieties": [
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 32.0,
          "pct": 27.4
        },
        {
          "name": "Auxerrois",
          "color": "white",
          "ha": 17.0,
          "pct": 14.3
        },
        {
          "name": "Elbling",
          "color": "white",
          "ha": 16.0,
          "pct": 13.4
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 14.0,
          "pct": 12.1
        },
        {
          "name": "Sonstige",
          "color": null,
          "ha": 13.0,
          "pct": 11.2
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 11.0,
          "pct": 9.4
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 9.0,
          "pct": 7.4
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 6.0,
          "pct": 4.8
        }
      ]
    },
    "Obermosel": {
      "totalHa": 742.0,
      "year": 2023,
      "complete": true,
      "notes": "Elbling covers 409 hectares, 55.2% of the Bereich, and 99.9% of all German Elbling grows in the Mosel, almost entirely here. Riesling accounts for 18 hectares, 2.5%, the lowest share of any Mosel Bereich; Grauburgunder at 10.6% is now several times larger. The soil is Muschelkalk rather than slate.",
      "varieties": [
        {
          "name": "Elbling",
          "color": "white",
          "ha": 409.0,
          "pct": 55.2
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 79.0,
          "pct": 10.6
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 57.0,
          "pct": 7.7
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 57.0,
          "pct": 7.6
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 31.0,
          "pct": 4.2
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 30.0,
          "pct": 4.1
        },
        {
          "name": "Auxerrois",
          "color": "white",
          "ha": 21.0,
          "pct": 2.8
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 18.0,
          "pct": 2.5
        },
        {
          "name": "Chardonnay",
          "color": "white",
          "ha": 18.0,
          "pct": 2.4
        },
        {
          "name": "Dornfelder",
          "color": "red",
          "ha": 12.0,
          "pct": 1.6
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 9.0,
          "pct": 1.2
        }
      ]
    },
    "Ruwer": {
      "totalHa": 180.0,
      "year": 2023,
      "complete": true,
      "notes": "Riesling occupies 154 of the Bereich's 180 hectares, 85.7%, and the statistical office lists no red variety at Bereich level. At 180 hectares it is the smallest Bereich in Rheinland-Pfalz, roughly a thirtieth the size of neighboring Bernkastel.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 154.0,
          "pct": 85.7
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 18.0,
          "pct": 9.7
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 8.0,
          "pct": 4.5
        }
      ]
    },
    "Saar": {
      "totalHa": 793.0,
      "year": 2023,
      "complete": true,
      "notes": "Riesling covers 662 of 793 hectares, 83.5%, second only to the Ruwer among German Bereiche. Reds total 5.4%. Saar plantings have held flat or grown slightly while the wider Mosel has contracted 26.5% since 1999.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 662.0,
          "pct": 83.5
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 41.0,
          "pct": 5.1
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 30.0,
          "pct": 3.8
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 21.0,
          "pct": 2.6
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 17.0,
          "pct": 2.1
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 12.0,
          "pct": 1.6
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 10.0,
          "pct": 1.3
        }
      ]
    }
  },
  "Nahe": {
    "Nahetal": {
      "totalHa": 4250.0,
      "year": 2023,
      "complete": true,
      "notes": "Riesling leads at 29.3%, the lowest share of any Bereich in the Mosel, Rheingau or Mittelrhein tier, and no other variety exceeds 11%. Dornfelder at 377 hectares exceeds Spätburgunder at 299. Müller-Thurgau remains 469 hectares, 11%.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 1244.0,
          "pct": 29.3
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 469.0,
          "pct": 11.0
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 396.0,
          "pct": 9.3
        },
        {
          "name": "Dornfelder",
          "color": "red",
          "ha": 377.0,
          "pct": 8.9
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 333.0,
          "pct": 7.8
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 299.0,
          "pct": 7.0
        },
        {
          "name": "Silvaner",
          "color": "white",
          "ha": 177.0,
          "pct": 4.2
        },
        {
          "name": "Bacchus",
          "color": "white",
          "ha": 120.0,
          "pct": 2.8
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 105.0,
          "pct": 2.5
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 105.0,
          "pct": 2.5
        },
        {
          "name": "Scheurebe",
          "color": "white",
          "ha": 101.0,
          "pct": 2.4
        },
        {
          "name": "Regent",
          "color": "red",
          "ha": 88.0,
          "pct": 2.1
        },
        {
          "name": "Chardonnay",
          "color": "white",
          "ha": 75.0,
          "pct": 1.8
        },
        {
          "name": "Portugieser",
          "color": "red",
          "ha": 69.0,
          "pct": 1.6
        },
        {
          "name": "Sauvignon blanc",
          "color": "white",
          "ha": 60.0,
          "pct": 1.4
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 53.0,
          "pct": 1.3
        },
        {
          "name": "Gewürztraminer",
          "color": "white",
          "ha": 30.0,
          "pct": 0.7
        },
        {
          "name": "Merlot",
          "color": "red",
          "ha": 27.0,
          "pct": 0.6
        },
        {
          "name": "Saint Laurent",
          "color": "red",
          "ha": 20.0,
          "pct": 0.5
        },
        {
          "name": "Muskateller",
          "color": "white",
          "ha": 17.0,
          "pct": 0.4
        },
        {
          "name": "Würzer",
          "color": "white",
          "ha": 17.0,
          "pct": 0.4
        },
        {
          "name": "Frühburgunder",
          "color": "red",
          "ha": 18.0,
          "pct": 0.4
        },
        {
          "name": "Cabernet Sauvignon",
          "color": "red",
          "ha": 16.0,
          "pct": 0.4
        },
        {
          "name": "Dunkelfelder",
          "color": "red",
          "ha": 15.0,
          "pct": 0.4
        },
        {
          "name": "Faberrebe",
          "color": "white",
          "ha": 11.0,
          "pct": 0.2
        },
        {
          "name": "Phoenix",
          "color": "white",
          "ha": 10.0,
          "pct": 0.2
        }
      ]
    }
  },
  "Pfalz": {
    "Mittelhaardt/Deutsche Weinstraße": {
      "totalHa": 11060.0,
      "year": 2023,
      "complete": true,
      "notes": "Riesling covers 3,633 hectares, 32.8%, the largest single block of Riesling in Germany and nearly double the share in the neighboring Südliche Weinstraße. Portugieser remains the fifth variety at 568 hectares. Dornfelder at 921 hectares is the leading red.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 3633.0,
          "pct": 32.8
        },
        {
          "name": "Dornfelder",
          "color": "red",
          "ha": 921.0,
          "pct": 8.3
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 829.0,
          "pct": 7.5
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 816.0,
          "pct": 7.4
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 643.0,
          "pct": 5.8
        },
        {
          "name": "Portugieser",
          "color": "red",
          "ha": 568.0,
          "pct": 5.1
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 545.0,
          "pct": 4.9
        },
        {
          "name": "Chardonnay",
          "color": "white",
          "ha": 456.0,
          "pct": 4.1
        },
        {
          "name": "Sauvignon blanc",
          "color": "white",
          "ha": 352.0,
          "pct": 3.2
        },
        {
          "name": "Merlot",
          "color": "red",
          "ha": 229.0,
          "pct": 2.1
        },
        {
          "name": "Gewürztraminer",
          "color": "white",
          "ha": 217.0,
          "pct": 2.0
        },
        {
          "name": "Scheurebe",
          "color": "white",
          "ha": 160.0,
          "pct": 1.4
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 149.0,
          "pct": 1.3
        },
        {
          "name": "Silvaner",
          "color": "white",
          "ha": 147.0,
          "pct": 1.3
        },
        {
          "name": "Regent",
          "color": "red",
          "ha": 135.0,
          "pct": 1.2
        },
        {
          "name": "Cabernet Sauvignon",
          "color": "red",
          "ha": 132.0,
          "pct": 1.2
        },
        {
          "name": "Saint Laurent",
          "color": "red",
          "ha": 125.0,
          "pct": 1.1
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 93.0,
          "pct": 0.8
        },
        {
          "name": "Muskateller",
          "color": "white",
          "ha": 64.0,
          "pct": 0.6
        },
        {
          "name": "Cabernet Dorsa",
          "color": "red",
          "ha": 64.0,
          "pct": 0.6
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 61.0,
          "pct": 0.6
        },
        {
          "name": "Cabernet blanc",
          "color": "white",
          "ha": 56.0,
          "pct": 0.5
        },
        {
          "name": "Morio-Muskat",
          "color": "white",
          "ha": 51.0,
          "pct": 0.5
        },
        {
          "name": "Acolon",
          "color": "red",
          "ha": 58.0,
          "pct": 0.5
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 54.0,
          "pct": 0.5
        },
        {
          "name": "Auxerrois",
          "color": "white",
          "ha": 41.0,
          "pct": 0.4
        },
        {
          "name": "Cabernet Franc",
          "color": "red",
          "ha": 45.0,
          "pct": 0.4
        },
        {
          "name": "Ortega",
          "color": "white",
          "ha": 36.0,
          "pct": 0.3
        },
        {
          "name": "Bacchus",
          "color": "white",
          "ha": 31.0,
          "pct": 0.3
        },
        {
          "name": "Syrah",
          "color": "red",
          "ha": 38.0,
          "pct": 0.3
        },
        {
          "name": "Dunkelfelder",
          "color": "red",
          "ha": 34.0,
          "pct": 0.3
        },
        {
          "name": "Cabernet Mitos",
          "color": "red",
          "ha": 32.0,
          "pct": 0.3
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 31.0,
          "pct": 0.3
        },
        {
          "name": "Heroldrebe",
          "color": "red",
          "ha": 30.0,
          "pct": 0.3
        },
        {
          "name": "Huxelrebe",
          "color": "white",
          "ha": 22.0,
          "pct": 0.2
        },
        {
          "name": "Sauvignac",
          "color": "white",
          "ha": 21.0,
          "pct": 0.2
        },
        {
          "name": "Souvignier gris",
          "color": "white",
          "ha": 21.0,
          "pct": 0.2
        },
        {
          "name": "Goldmuskateller",
          "color": "white",
          "ha": 19.0,
          "pct": 0.2
        },
        {
          "name": "Solaris",
          "color": "white",
          "ha": 18.0,
          "pct": 0.2
        },
        {
          "name": "Cabernet Cubin",
          "color": "red",
          "ha": 20.0,
          "pct": 0.2
        },
        {
          "name": "Frühburgunder",
          "color": "red",
          "ha": 20.0,
          "pct": 0.2
        },
        {
          "name": "Rieslaner",
          "color": "white",
          "ha": 17.0,
          "pct": 0.1
        },
        {
          "name": "Grüner Veltliner",
          "color": "white",
          "ha": 14.0,
          "pct": 0.1
        },
        {
          "name": "Muscaris",
          "color": "white",
          "ha": 10.0,
          "pct": 0.1
        }
      ]
    },
    "Südliche Weinstraße": {
      "totalHa": 12733.0,
      "year": 2023,
      "complete": true,
      "notes": "At 12,733 hectares this is the largest Bereich in Germany by planted area. Riesling covers only 18.2%. The Bereich carries the country's largest plantings of Grauburgunder (1,419 ha), Chardonnay (513 ha) and Sauvignon blanc (442 ha), and its 1,532 hectares of Dornfelder is the largest red planting of any German Bereich.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 2321.0,
          "pct": 18.2
        },
        {
          "name": "Dornfelder",
          "color": "red",
          "ha": 1532.0,
          "pct": 12.0
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 1419.0,
          "pct": 11.1
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 1045.0,
          "pct": 8.2
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 910.0,
          "pct": 7.1
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 848.0,
          "pct": 6.7
        },
        {
          "name": "Chardonnay",
          "color": "white",
          "ha": 513.0,
          "pct": 4.0
        },
        {
          "name": "Portugieser",
          "color": "red",
          "ha": 471.0,
          "pct": 3.7
        },
        {
          "name": "Sauvignon blanc",
          "color": "white",
          "ha": 442.0,
          "pct": 3.5
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 435.0,
          "pct": 3.4
        },
        {
          "name": "Regent",
          "color": "red",
          "ha": 320.0,
          "pct": 2.5
        },
        {
          "name": "Silvaner",
          "color": "white",
          "ha": 302.0,
          "pct": 2.4
        },
        {
          "name": "Gewürztraminer",
          "color": "white",
          "ha": 291.0,
          "pct": 2.3
        },
        {
          "name": "Merlot",
          "color": "red",
          "ha": 200.0,
          "pct": 1.6
        },
        {
          "name": "Scheurebe",
          "color": "white",
          "ha": 168.0,
          "pct": 1.3
        },
        {
          "name": "Muskateller",
          "color": "white",
          "ha": 122.0,
          "pct": 1.0
        },
        {
          "name": "Saint Laurent",
          "color": "red",
          "ha": 130.0,
          "pct": 1.0
        },
        {
          "name": "Cabernet Sauvignon",
          "color": "red",
          "ha": 125.0,
          "pct": 1.0
        },
        {
          "name": "Morio-Muskat",
          "color": "white",
          "ha": 110.0,
          "pct": 0.9
        },
        {
          "name": "Ortega",
          "color": "white",
          "ha": 96.0,
          "pct": 0.8
        },
        {
          "name": "Cabernet blanc",
          "color": "white",
          "ha": 90.0,
          "pct": 0.7
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 87.0,
          "pct": 0.7
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 86.0,
          "pct": 0.7
        },
        {
          "name": "Huxelrebe",
          "color": "white",
          "ha": 64.0,
          "pct": 0.5
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 69.0,
          "pct": 0.5
        },
        {
          "name": "Dunkelfelder",
          "color": "red",
          "ha": 62.0,
          "pct": 0.5
        },
        {
          "name": "Bacchus",
          "color": "white",
          "ha": 53.0,
          "pct": 0.4
        },
        {
          "name": "Auxerrois",
          "color": "white",
          "ha": 50.0,
          "pct": 0.4
        },
        {
          "name": "Sauvignac",
          "color": "white",
          "ha": 41.0,
          "pct": 0.3
        },
        {
          "name": "Acolon",
          "color": "red",
          "ha": 37.0,
          "pct": 0.3
        },
        {
          "name": "Cabernet Mitos",
          "color": "red",
          "ha": 34.0,
          "pct": 0.3
        },
        {
          "name": "Syrah",
          "color": "red",
          "ha": 33.0,
          "pct": 0.3
        },
        {
          "name": "Solaris",
          "color": "white",
          "ha": 26.0,
          "pct": 0.2
        },
        {
          "name": "Souvignier gris",
          "color": "white",
          "ha": 24.0,
          "pct": 0.2
        },
        {
          "name": "Goldmuskateller",
          "color": "white",
          "ha": 21.0,
          "pct": 0.2
        },
        {
          "name": "Cabernet Dorsa",
          "color": "red",
          "ha": 27.0,
          "pct": 0.2
        },
        {
          "name": "Frühburgunder",
          "color": "red",
          "ha": 26.0,
          "pct": 0.2
        },
        {
          "name": "Heroldrebe",
          "color": "red",
          "ha": 25.0,
          "pct": 0.2
        },
        {
          "name": "Cabernet Franc",
          "color": "red",
          "ha": 19.0,
          "pct": 0.2
        },
        {
          "name": "Siegerrebe",
          "color": "white",
          "ha": 18.0,
          "pct": 0.1
        },
        {
          "name": "Rieslaner",
          "color": "white",
          "ha": 13.0,
          "pct": 0.1
        },
        {
          "name": "Muscaris",
          "color": "white",
          "ha": 12.0,
          "pct": 0.1
        },
        {
          "name": "Calardis blanc",
          "color": "white",
          "ha": 12.0,
          "pct": 0.1
        }
      ]
    }
  },
  "Rheingau": {
    "Johannisberg": {
      "totalHa": 3157.0,
      "year": 2023,
      "complete": false,
      "notes": "The Rheingau has a single Bereich, Johannisberg, so the Anbaugebiet figures are the Bereich figures. Riesling covers 76.1% of the yielding area, the highest share of any wine region in the world, and Spätburgunder 12.6%, concentrated around Assmannshausen; the two account for more than 91% of plantings. Yielding area in 2023 was 3,157 hectares, 2,697 white and 460 red. VDP members farm 1,098 hectares, more than a third of the region, the highest VDP share of any German Anbaugebiet. Erstes Gewächs was introduced here in 1999 and written into Hessian law, unlike the VDP's private classification elsewhere.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 2402.0,
          "pct": 76.1
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 398.0,
          "pct": 12.6
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 294.0,
          "pct": 9.3
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 63.0,
          "pct": 2.0
        }
      ]
    }
  },
  "Rheinhessen": {
    "Bingen": {
      "totalHa": 8928.0,
      "year": 2023,
      "complete": true,
      "notes": "Silvaner covers 806 hectares, 9%, the highest share of the three Rheinhessen Bereiche. Riesling leads at only 17.7%, with Müller-Thurgau at 13.5% and Dornfelder at 10.7% close behind. Rheinhessen as a whole holds 75% of German Silvaner outside Franken.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 1580.0,
          "pct": 17.7
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 1202.0,
          "pct": 13.5
        },
        {
          "name": "Dornfelder",
          "color": "red",
          "ha": 957.0,
          "pct": 10.7
        },
        {
          "name": "Silvaner",
          "color": "white",
          "ha": 806.0,
          "pct": 9.0
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 749.0,
          "pct": 8.4
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 514.0,
          "pct": 5.8
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 467.0,
          "pct": 5.2
        },
        {
          "name": "Portugieser",
          "color": "red",
          "ha": 363.0,
          "pct": 4.1
        },
        {
          "name": "Chardonnay",
          "color": "white",
          "ha": 355.0,
          "pct": 4.0
        },
        {
          "name": "Scheurebe",
          "color": "white",
          "ha": 285.0,
          "pct": 3.2
        },
        {
          "name": "Regent",
          "color": "red",
          "ha": 238.0,
          "pct": 2.7
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 203.0,
          "pct": 2.3
        },
        {
          "name": "Sauvignon blanc",
          "color": "white",
          "ha": 189.0,
          "pct": 2.1
        },
        {
          "name": "Bacchus",
          "color": "white",
          "ha": 169.0,
          "pct": 1.9
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 103.0,
          "pct": 1.2
        },
        {
          "name": "Faberrebe",
          "color": "white",
          "ha": 66.0,
          "pct": 0.7
        },
        {
          "name": "Gewürztraminer",
          "color": "white",
          "ha": 61.0,
          "pct": 0.7
        },
        {
          "name": "Merlot",
          "color": "red",
          "ha": 65.0,
          "pct": 0.7
        },
        {
          "name": "Saint Laurent",
          "color": "red",
          "ha": 63.0,
          "pct": 0.7
        },
        {
          "name": "Ortega",
          "color": "white",
          "ha": 53.0,
          "pct": 0.6
        },
        {
          "name": "Huxelrebe",
          "color": "white",
          "ha": 49.0,
          "pct": 0.6
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 53.0,
          "pct": 0.6
        },
        {
          "name": "Cabernet Sauvignon",
          "color": "red",
          "ha": 44.0,
          "pct": 0.5
        },
        {
          "name": "Frühburgunder",
          "color": "red",
          "ha": 41.0,
          "pct": 0.5
        },
        {
          "name": "Morio-Muskat",
          "color": "white",
          "ha": 40.0,
          "pct": 0.4
        },
        {
          "name": "Muskateller",
          "color": "white",
          "ha": 31.0,
          "pct": 0.3
        },
        {
          "name": "Souvignier gris",
          "color": "white",
          "ha": 27.0,
          "pct": 0.3
        },
        {
          "name": "Solaris",
          "color": "white",
          "ha": 24.0,
          "pct": 0.3
        },
        {
          "name": "Cabernet blanc",
          "color": "white",
          "ha": 20.0,
          "pct": 0.2
        },
        {
          "name": "Johanniter",
          "color": "white",
          "ha": 14.0,
          "pct": 0.2
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 18.0,
          "pct": 0.2
        },
        {
          "name": "Acolon",
          "color": "red",
          "ha": 14.0,
          "pct": 0.2
        },
        {
          "name": "Würzer",
          "color": "white",
          "ha": 11.0,
          "pct": 0.1
        },
        {
          "name": "Muscaris",
          "color": "white",
          "ha": 11.0,
          "pct": 0.1
        },
        {
          "name": "Sauvignac",
          "color": "white",
          "ha": 10.0,
          "pct": 0.1
        },
        {
          "name": "Cabernet Dorsa",
          "color": "red",
          "ha": 11.0,
          "pct": 0.1
        },
        {
          "name": "Dunkelfelder",
          "color": "red",
          "ha": 11.0,
          "pct": 0.1
        },
        {
          "name": "Cabernet Mitos",
          "color": "red",
          "ha": 11.0,
          "pct": 0.1
        }
      ]
    },
    "Nierstein": {
      "totalHa": 10460.0,
      "year": 2023,
      "complete": true,
      "notes": "At 10,460 hectares this is the largest Bereich in Germany, exceeding the whole of the Nahe or the Mosel. Riesling leads at 20.4%, concentrated on the Roter Hang; Müller-Thurgau at 15% and Dornfelder at 10.5% occupy much of the land away from the river terrace. Grauburgunder has reached 989 hectares.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 2138.0,
          "pct": 20.4
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 1564.0,
          "pct": 15.0
        },
        {
          "name": "Dornfelder",
          "color": "red",
          "ha": 1102.0,
          "pct": 10.5
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 989.0,
          "pct": 9.5
        },
        {
          "name": "Silvaner",
          "color": "white",
          "ha": 721.0,
          "pct": 6.9
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 638.0,
          "pct": 6.1
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 532.0,
          "pct": 5.1
        },
        {
          "name": "Chardonnay",
          "color": "white",
          "ha": 393.0,
          "pct": 3.8
        },
        {
          "name": "Scheurebe",
          "color": "white",
          "ha": 259.0,
          "pct": 2.5
        },
        {
          "name": "Portugieser",
          "color": "red",
          "ha": 261.0,
          "pct": 2.5
        },
        {
          "name": "Sauvignon blanc",
          "color": "white",
          "ha": 227.0,
          "pct": 2.2
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 222.0,
          "pct": 2.1
        },
        {
          "name": "Regent",
          "color": "red",
          "ha": 168.0,
          "pct": 1.6
        },
        {
          "name": "Bacchus",
          "color": "white",
          "ha": 149.0,
          "pct": 1.4
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 117.0,
          "pct": 1.1
        },
        {
          "name": "Merlot",
          "color": "red",
          "ha": 112.0,
          "pct": 1.1
        },
        {
          "name": "Gewürztraminer",
          "color": "white",
          "ha": 99.0,
          "pct": 0.9
        },
        {
          "name": "Saint Laurent",
          "color": "red",
          "ha": 88.0,
          "pct": 0.8
        },
        {
          "name": "Huxelrebe",
          "color": "white",
          "ha": 77.0,
          "pct": 0.7
        },
        {
          "name": "Ortega",
          "color": "white",
          "ha": 71.0,
          "pct": 0.7
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 62.0,
          "pct": 0.6
        },
        {
          "name": "Faberrebe",
          "color": "white",
          "ha": 52.0,
          "pct": 0.5
        },
        {
          "name": "Cabernet Sauvignon",
          "color": "red",
          "ha": 48.0,
          "pct": 0.5
        },
        {
          "name": "Morio-Muskat",
          "color": "white",
          "ha": 47.0,
          "pct": 0.4
        },
        {
          "name": "Souvignier gris",
          "color": "white",
          "ha": 44.0,
          "pct": 0.4
        },
        {
          "name": "Muskateller",
          "color": "white",
          "ha": 29.0,
          "pct": 0.3
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 27.0,
          "pct": 0.3
        },
        {
          "name": "Cabernet blanc",
          "color": "white",
          "ha": 22.0,
          "pct": 0.2
        },
        {
          "name": "Johanniter",
          "color": "white",
          "ha": 18.0,
          "pct": 0.2
        },
        {
          "name": "Auxerrois",
          "color": "white",
          "ha": 18.0,
          "pct": 0.2
        },
        {
          "name": "Cabernet Dorsa",
          "color": "red",
          "ha": 24.0,
          "pct": 0.2
        },
        {
          "name": "Cabernet Mitos",
          "color": "red",
          "ha": 23.0,
          "pct": 0.2
        },
        {
          "name": "Acolon",
          "color": "red",
          "ha": 20.0,
          "pct": 0.2
        },
        {
          "name": "Frühburgunder",
          "color": "red",
          "ha": 17.0,
          "pct": 0.2
        },
        {
          "name": "Muscaris",
          "color": "white",
          "ha": 12.0,
          "pct": 0.1
        },
        {
          "name": "Sauvignac",
          "color": "white",
          "ha": 12.0,
          "pct": 0.1
        },
        {
          "name": "Goldmuskateller",
          "color": "white",
          "ha": 11.0,
          "pct": 0.1
        },
        {
          "name": "Solaris",
          "color": "white",
          "ha": 11.0,
          "pct": 0.1
        },
        {
          "name": "Phoenix",
          "color": "white",
          "ha": 10.0,
          "pct": 0.1
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 15.0,
          "pct": 0.1
        },
        {
          "name": "Dunkelfelder",
          "color": "red",
          "ha": 11.0,
          "pct": 0.1
        }
      ]
    },
    "Wonnegau": {
      "totalHa": 8111.0,
      "year": 2023,
      "complete": true,
      "notes": "Riesling covers 20.5%, the highest of the three Rheinhessen Bereiche. Sauvignon blanc at 233 hectares is the largest planting of any Rheinhessen Bereich. Dornfelder remains 11.9%, and Müller-Thurgau 13.2%.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 1665.0,
          "pct": 20.5
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 1068.0,
          "pct": 13.2
        },
        {
          "name": "Dornfelder",
          "color": "red",
          "ha": 963.0,
          "pct": 11.9
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 686.0,
          "pct": 8.5
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 535.0,
          "pct": 6.6
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 459.0,
          "pct": 5.7
        },
        {
          "name": "Silvaner",
          "color": "white",
          "ha": 349.0,
          "pct": 4.3
        },
        {
          "name": "Chardonnay",
          "color": "white",
          "ha": 339.0,
          "pct": 4.2
        },
        {
          "name": "Portugieser",
          "color": "red",
          "ha": 261.0,
          "pct": 3.2
        },
        {
          "name": "Sauvignon blanc",
          "color": "white",
          "ha": 233.0,
          "pct": 2.9
        },
        {
          "name": "Scheurebe",
          "color": "white",
          "ha": 199.0,
          "pct": 2.5
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 149.0,
          "pct": 1.8
        },
        {
          "name": "Regent",
          "color": "red",
          "ha": 147.0,
          "pct": 1.8
        },
        {
          "name": "Huxelrebe",
          "color": "white",
          "ha": 98.0,
          "pct": 1.2
        },
        {
          "name": "Bacchus",
          "color": "white",
          "ha": 95.0,
          "pct": 1.2
        },
        {
          "name": "Sonstige (weiß)",
          "color": "white",
          "ha": 97.0,
          "pct": 1.2
        },
        {
          "name": "Saint Laurent",
          "color": "red",
          "ha": 96.0,
          "pct": 1.2
        },
        {
          "name": "Sonstige (rot)",
          "color": "red",
          "ha": 81.0,
          "pct": 1.0
        },
        {
          "name": "Gewürztraminer",
          "color": "white",
          "ha": 73.0,
          "pct": 0.9
        },
        {
          "name": "Merlot",
          "color": "red",
          "ha": 70.0,
          "pct": 0.9
        },
        {
          "name": "Morio-Muskat",
          "color": "white",
          "ha": 51.0,
          "pct": 0.6
        },
        {
          "name": "Ortega",
          "color": "white",
          "ha": 48.0,
          "pct": 0.6
        },
        {
          "name": "Muskateller",
          "color": "white",
          "ha": 48.0,
          "pct": 0.6
        },
        {
          "name": "Faberrebe",
          "color": "white",
          "ha": 41.0,
          "pct": 0.5
        },
        {
          "name": "Cabernet Sauvignon",
          "color": "red",
          "ha": 40.0,
          "pct": 0.5
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 32.0,
          "pct": 0.4
        },
        {
          "name": "Souvignier gris",
          "color": "white",
          "ha": 25.0,
          "pct": 0.3
        },
        {
          "name": "Solaris",
          "color": "white",
          "ha": 22.0,
          "pct": 0.3
        },
        {
          "name": "Cabernet Mitos",
          "color": "red",
          "ha": 21.0,
          "pct": 0.3
        },
        {
          "name": "Cabernet blanc",
          "color": "white",
          "ha": 19.0,
          "pct": 0.2
        },
        {
          "name": "Siegerrebe",
          "color": "white",
          "ha": 17.0,
          "pct": 0.2
        },
        {
          "name": "Johanniter",
          "color": "white",
          "ha": 15.0,
          "pct": 0.2
        },
        {
          "name": "Goldmuskateller",
          "color": "white",
          "ha": 15.0,
          "pct": 0.2
        },
        {
          "name": "Cabernet Dorsa",
          "color": "red",
          "ha": 16.0,
          "pct": 0.2
        },
        {
          "name": "Frühburgunder",
          "color": "red",
          "ha": 15.0,
          "pct": 0.2
        },
        {
          "name": "Acolon",
          "color": "red",
          "ha": 13.0,
          "pct": 0.2
        },
        {
          "name": "Muscaris",
          "color": "white",
          "ha": 12.0,
          "pct": 0.1
        }
      ]
    }
  },
  "Württemberg": {
    "Bayerischer Bodensee": {
      "totalHa": 12.6,
      "year": 2025,
      "complete": false,
      "notes": null,
      "varieties": []
    },
    "Kocher-Jagst-Tauber": {
      "totalHa": 375.0,
      "year": 2024,
      "complete": false,
      "notes": "Württemberg's smallest Bereich at 375 hectares, on Muschelkalk in the Kocher, Jagst and Tauber valleys. Schwarzriesling leads at 18.4%, the only German Bereich where it is the largest variety. Trollinger covers 1.6%, against 21.8% in the Remstal.",
      "varieties": [
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 69.0,
          "pct": 18.4
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 46.0,
          "pct": 12.3
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 42.0,
          "pct": 11.2
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 26.0,
          "pct": 6.9
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 16.0,
          "pct": 4.3
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 15.0,
          "pct": 4.0
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 9.0,
          "pct": 2.4
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 9.0,
          "pct": 2.4
        },
        {
          "name": "Trollinger",
          "color": "red",
          "ha": 6.0,
          "pct": 1.6
        }
      ]
    },
    "Neckar-Alb": {
      "totalHa": 47.1,
      "year": 2025,
      "complete": false,
      "notes": null,
      "varieties": []
    },
    "Remstal": {
      "totalHa": 1758.0,
      "year": 2024,
      "complete": false,
      "notes": "Trollinger covers 21.8%, the highest share of any German Bereich. Riesling follows at 18.8% and Lemberger at 9.8%. The Bereich was renamed from Remstal-Stuttgart in the Weinbergsrolle revision of June 2025; the statistical office still publishes it under the former name.",
      "varieties": [
        {
          "name": "Trollinger",
          "color": "red",
          "ha": 383.0,
          "pct": 21.8
        },
        {
          "name": "Riesling",
          "color": "white",
          "ha": 331.0,
          "pct": 18.8
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 173.0,
          "pct": 9.8
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 128.0,
          "pct": 7.3
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 56.0,
          "pct": 3.2
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 54.0,
          "pct": 3.1
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 55.0,
          "pct": 3.1
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 53.0,
          "pct": 3.0
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 46.0,
          "pct": 2.6
        }
      ]
    },
    "Württembergisch Unterland": {
      "totalHa": 8906.0,
      "year": 2024,
      "complete": false,
      "notes": "At 8,906 hectares the Bereich holds 80% of Württemberg. It carries 1,545 hectares of Lemberger and 1,512 of Trollinger, the majority of both grapes in Germany, and 994 hectares of Schwarzriesling. Riesling is the largest single variety at 1,708 hectares, 19.2%.",
      "varieties": [
        {
          "name": "Riesling",
          "color": "white",
          "ha": 1708.0,
          "pct": 19.2
        },
        {
          "name": "Lemberger",
          "color": "red",
          "ha": 1545.0,
          "pct": 17.3
        },
        {
          "name": "Trollinger",
          "color": "red",
          "ha": 1512.0,
          "pct": 17.0
        },
        {
          "name": "Schwarzriesling",
          "color": "red",
          "ha": 994.0,
          "pct": 11.2
        },
        {
          "name": "Spätburgunder",
          "color": "red",
          "ha": 704.0,
          "pct": 7.9
        },
        {
          "name": "Grauburgunder",
          "color": "white",
          "ha": 255.0,
          "pct": 2.9
        },
        {
          "name": "Weißburgunder",
          "color": "white",
          "ha": 191.0,
          "pct": 2.1
        },
        {
          "name": "Kerner",
          "color": "white",
          "ha": 181.0,
          "pct": 2.0
        },
        {
          "name": "Müller-Thurgau",
          "color": "white",
          "ha": 163.0,
          "pct": 1.8
        }
      ]
    },
    "Württembergischer Bodensee": {
      "totalHa": 66.1,
      "year": 2025,
      "complete": false,
      "notes": null,
      "varieties": []
    }
  }
};

export const REGION_STATS = {
  "Franken": {
    "totalHa": 6130.0,
    "year": 2018,
    "notes": "Silvaner covers 1,501 hectares, 24.5%, the largest planting of the variety in Germany and the reason Franken is treated as its home. Müller-Thurgau is marginally larger at 1,538 hectares, 25.1%, a legacy of twentieth century plantings that has been falling since. Bacchus at 750 hectares is the third variety and is grown almost nowhere else in quantity. Domina, at 322 hectares, is the leading red and is effectively a Franken variety: the region holds 88% of the German total. Riesling covers only 5.5%. The three Bereiche Mainviereck, Maindreieck and Steigerwald were abolished in 2017 and replaced by twelve new ones, so no Bereich-level statistics exist.",
    "bereiche": [],
    "varieties": [
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 1538.0,
        "pct": 25.1
      },
      {
        "name": "Silvaner",
        "color": "white",
        "ha": 1501.0,
        "pct": 24.5
      },
      {
        "name": "Bacchus",
        "color": "white",
        "ha": 750.0,
        "pct": 12.2
      },
      {
        "name": "Riesling",
        "color": "white",
        "ha": 336.0,
        "pct": 5.5
      },
      {
        "name": "Domina",
        "color": "red",
        "ha": 322.0,
        "pct": 5.3
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 263.0,
        "pct": 4.3
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 195.0,
        "pct": 3.2
      },
      {
        "name": "Kerner",
        "color": "white",
        "ha": 180.0,
        "pct": 2.9
      },
      {
        "name": "Scheurebe",
        "color": "white",
        "ha": 168.0,
        "pct": 2.7
      },
      {
        "name": "Dornfelder",
        "color": "red",
        "ha": 139.0,
        "pct": 2.3
      },
      {
        "name": "Regent",
        "color": "red",
        "ha": 128.0,
        "pct": 2.1
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 83.0,
        "pct": 1.4
      },
      {
        "name": "Schwarzriesling",
        "color": "red",
        "ha": 69.0,
        "pct": 1.1
      },
      {
        "name": "Acolon",
        "color": "red",
        "ha": 50.0,
        "pct": 0.8
      },
      {
        "name": "Portugieser",
        "color": "red",
        "ha": 50.0,
        "pct": 0.8
      },
      {
        "name": "Gewürztraminer",
        "color": "white",
        "ha": 43.0,
        "pct": 0.7
      },
      {
        "name": "Sauvignon blanc",
        "color": "white",
        "ha": 36.0,
        "pct": 0.6
      },
      {
        "name": "Rieslaner",
        "color": "white",
        "ha": 31.0,
        "pct": 0.5
      },
      {
        "name": "Chardonnay",
        "color": "white",
        "ha": 24.0,
        "pct": 0.4
      },
      {
        "name": "Blauer Silvaner",
        "color": "white",
        "ha": 22.0,
        "pct": 0.4
      },
      {
        "name": "Johanniter",
        "color": "white",
        "ha": 16.0,
        "pct": 0.3
      },
      {
        "name": "Ortega",
        "color": "white",
        "ha": 16.0,
        "pct": 0.3
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 18.0,
        "pct": 0.3
      },
      {
        "name": "Cabernet Dorsa",
        "color": "red",
        "ha": 18.0,
        "pct": 0.3
      },
      {
        "name": "Frühburgunder",
        "color": "red",
        "ha": 16.0,
        "pct": 0.3
      },
      {
        "name": "Zweigelt",
        "color": "red",
        "ha": 16.0,
        "pct": 0.3
      },
      {
        "name": "Gelber Muskateller",
        "color": "white",
        "ha": 11.0,
        "pct": 0.2
      },
      {
        "name": "Merlot",
        "color": "red",
        "ha": 11.0,
        "pct": 0.2
      },
      {
        "name": "Perle",
        "color": "white",
        "ha": 8.0,
        "pct": 0.1
      },
      {
        "name": "Cabernet blanc",
        "color": "white",
        "ha": 6.0,
        "pct": 0.1
      },
      {
        "name": "Solaris",
        "color": "white",
        "ha": 6.0,
        "pct": 0.1
      },
      {
        "name": "Viognier",
        "color": "white",
        "ha": 5.0,
        "pct": 0.1
      },
      {
        "name": "Faberrebe",
        "color": "white",
        "ha": 4.0,
        "pct": 0.1
      },
      {
        "name": "Lemberger",
        "color": "red",
        "ha": 6.0,
        "pct": 0.1
      },
      {
        "name": "Cabernet Sauvignon",
        "color": "red",
        "ha": 4.0,
        "pct": 0.1
      },
      {
        "name": "Saint Laurent",
        "color": "red",
        "ha": 4.0,
        "pct": 0.1
      },
      {
        "name": "Auxerrois",
        "color": "white",
        "ha": 2.0,
        "pct": 0.0
      },
      {
        "name": "Morio-Muskat",
        "color": "white",
        "ha": 2.0,
        "pct": 0.0
      },
      {
        "name": "Muscaris",
        "color": "white",
        "ha": 2.0,
        "pct": 0.0
      },
      {
        "name": "Helios",
        "color": "white",
        "ha": 2.0,
        "pct": 0.0
      },
      {
        "name": "Cabernet Mitos",
        "color": "red",
        "ha": 3.0,
        "pct": 0.0
      },
      {
        "name": "Blauburger",
        "color": "red",
        "ha": 2.0,
        "pct": 0.0
      },
      {
        "name": "Tauberschwarz",
        "color": "red",
        "ha": 2.0,
        "pct": 0.0
      },
      {
        "name": "Sonstige (rot)",
        "color": "red",
        "ha": 3.0,
        "pct": 0.0
      }
    ]
  },
  "Hessische Bergstraße": {
    "totalHa": 453.0,
    "year": 2023,
    "notes": "Germany's smallest Anbaugebiet at roughly 450 hectares, split across two separated Bereiche: Starkenburg, running south from Darmstadt through Bensheim and Heppenheim, and Umstadt, the Odenwälder Weininsel around Groß-Umstadt. The Regierungspräsidium Darmstadt publishes variety data for the Anbaugebiet only and does not split it by Bereich. Riesling covers 35.6%, Grauburgunder 12.8% and Spätburgunder 10.8% of the 453 hectare yielding area. Co-operatives market 58.5% of the vineyard, against 4.4% in the Rheingau. Soils are calcareous loess and sand loess, Pararendzina and Rigosol, plus sandstone brown earths. The region is administered by the VDP under the Rheingau association.",
    "bereiche": [],
    "varieties": [
      {
        "name": "Riesling",
        "color": "white",
        "ha": 161.0,
        "pct": 35.6
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 140.0,
        "pct": 30.8
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 58.0,
        "pct": 12.8
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 49.0,
        "pct": 10.8
      },
      {
        "name": "Sonstige (rot)",
        "color": "red",
        "ha": 45.0,
        "pct": 10.0
      }
    ]
  },
  "Saale-Unstrut": {
    "totalHa": 786.0,
    "year": 2018,
    "notes": "Müller-Thurgau leads at 117 hectares, 14.9%, followed by Weißburgunder at 109 and Riesling at 70. Bacchus covers 50 hectares and Silvaner 48. The reds are led by Dornfelder at 54 hectares and Portugieser at 41, with Zweigelt at 25 hectares giving the region the largest Zweigelt planting in Germany. Gutedel at 21 hectares is unexpected this far north. The Anbaugebiet spans Sachsen-Anhalt, Thüringen and Brandenburg, and its three Bereiche are not reported separately by any statistical office.",
    "bereiche": [],
    "varieties": [
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 117.0,
        "pct": 14.9
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 109.0,
        "pct": 13.9
      },
      {
        "name": "Riesling",
        "color": "white",
        "ha": 70.0,
        "pct": 8.9
      },
      {
        "name": "Dornfelder",
        "color": "red",
        "ha": 54.0,
        "pct": 6.9
      },
      {
        "name": "Bacchus",
        "color": "white",
        "ha": 50.0,
        "pct": 6.4
      },
      {
        "name": "Silvaner",
        "color": "white",
        "ha": 48.0,
        "pct": 6.1
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 46.0,
        "pct": 5.9
      },
      {
        "name": "Portugieser",
        "color": "red",
        "ha": 41.0,
        "pct": 5.2
      },
      {
        "name": "Kerner",
        "color": "white",
        "ha": 36.0,
        "pct": 4.6
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 30.0,
        "pct": 3.8
      },
      {
        "name": "Gewürztraminer",
        "color": "white",
        "ha": 26.0,
        "pct": 3.3
      },
      {
        "name": "Zweigelt",
        "color": "red",
        "ha": 25.0,
        "pct": 3.2
      },
      {
        "name": "Gutedel",
        "color": "white",
        "ha": 21.0,
        "pct": 2.7
      },
      {
        "name": "Regent",
        "color": "red",
        "ha": 19.0,
        "pct": 2.4
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 15.0,
        "pct": 1.9
      },
      {
        "name": "Sonstige (rot)",
        "color": "red",
        "ha": 10.0,
        "pct": 1.3
      },
      {
        "name": "Sauvignon blanc",
        "color": "white",
        "ha": 9.0,
        "pct": 1.1
      },
      {
        "name": "Auxerrois",
        "color": "white",
        "ha": 7.0,
        "pct": 0.9
      },
      {
        "name": "Lemberger",
        "color": "red",
        "ha": 7.0,
        "pct": 0.9
      },
      {
        "name": "Frühburgunder",
        "color": "red",
        "ha": 6.0,
        "pct": 0.8
      },
      {
        "name": "Elbling",
        "color": "white",
        "ha": 5.0,
        "pct": 0.6
      },
      {
        "name": "Scheurebe",
        "color": "white",
        "ha": 5.0,
        "pct": 0.6
      },
      {
        "name": "Kernling",
        "color": "white",
        "ha": 4.0,
        "pct": 0.5
      },
      {
        "name": "Chardonnay",
        "color": "white",
        "ha": 3.0,
        "pct": 0.4
      },
      {
        "name": "Johanniter",
        "color": "white",
        "ha": 3.0,
        "pct": 0.4
      },
      {
        "name": "Ortega",
        "color": "white",
        "ha": 3.0,
        "pct": 0.4
      },
      {
        "name": "Cabernet Dorsa",
        "color": "red",
        "ha": 3.0,
        "pct": 0.4
      },
      {
        "name": "Cabernet Mitos",
        "color": "red",
        "ha": 3.0,
        "pct": 0.4
      },
      {
        "name": "Blauer Silvaner",
        "color": "white",
        "ha": 2.0,
        "pct": 0.3
      },
      {
        "name": "Solaris",
        "color": "white",
        "ha": 2.0,
        "pct": 0.3
      }
    ]
  },
  "Sachsen": {
    "totalHa": 501.0,
    "year": 2018,
    "notes": "Germany's smallest and most easterly Anbaugebiet at 501 hectares, of which 82% is white. Müller-Thurgau leads at 71 hectares, 14.2%, with Riesling at 68 and Weißburgunder at 62 close behind, so no variety dominates. Goldriesling covers 27 hectares and is grown nowhere else in Germany, making it the Sachsen equivalent of Elbling on the Obermosel. Gewürztraminer at 26 hectares and Scheurebe at 22 are unusually prominent for the area. Spätburgunder leads the reds at 39 hectares. Yields are the lowest in Germany at around 50 hectolitres per hectare. The two Bereiche, Meißen and Elstertal, are not reported separately.",
    "bereiche": [],
    "varieties": [
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 71.0,
        "pct": 14.2
      },
      {
        "name": "Riesling",
        "color": "white",
        "ha": 68.0,
        "pct": 13.6
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 62.0,
        "pct": 12.4
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 47.0,
        "pct": 9.4
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 39.0,
        "pct": 7.8
      },
      {
        "name": "Goldriesling",
        "color": "white",
        "ha": 27.0,
        "pct": 5.4
      },
      {
        "name": "Kerner",
        "color": "white",
        "ha": 27.0,
        "pct": 5.4
      },
      {
        "name": "Gewürztraminer",
        "color": "white",
        "ha": 26.0,
        "pct": 5.2
      },
      {
        "name": "Scheurebe",
        "color": "white",
        "ha": 22.0,
        "pct": 4.4
      },
      {
        "name": "Dornfelder",
        "color": "red",
        "ha": 19.0,
        "pct": 3.8
      },
      {
        "name": "Bacchus",
        "color": "white",
        "ha": 14.0,
        "pct": 2.8
      },
      {
        "name": "Regent",
        "color": "red",
        "ha": 11.0,
        "pct": 2.2
      },
      {
        "name": "Solaris",
        "color": "white",
        "ha": 10.0,
        "pct": 2.0
      },
      {
        "name": "Elbling",
        "color": "white",
        "ha": 9.0,
        "pct": 1.8
      },
      {
        "name": "Frühburgunder",
        "color": "red",
        "ha": 7.0,
        "pct": 1.4
      },
      {
        "name": "Cabernet blanc",
        "color": "white",
        "ha": 3.0,
        "pct": 0.6
      },
      {
        "name": "Chardonnay",
        "color": "white",
        "ha": 3.0,
        "pct": 0.6
      },
      {
        "name": "Johanniter",
        "color": "white",
        "ha": 3.0,
        "pct": 0.6
      },
      {
        "name": "Sauvignon blanc",
        "color": "white",
        "ha": 3.0,
        "pct": 0.6
      },
      {
        "name": "Souvignier gris",
        "color": "white",
        "ha": 3.0,
        "pct": 0.6
      },
      {
        "name": "Schwarzriesling",
        "color": "red",
        "ha": 3.0,
        "pct": 0.6
      },
      {
        "name": "Gutedel",
        "color": "white",
        "ha": 2.0,
        "pct": 0.4
      },
      {
        "name": "Morio-Muskat",
        "color": "white",
        "ha": 2.0,
        "pct": 0.4
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 2.0,
        "pct": 0.4
      },
      {
        "name": "Domina",
        "color": "red",
        "ha": 2.0,
        "pct": 0.4
      },
      {
        "name": "Lemberger",
        "color": "red",
        "ha": 2.0,
        "pct": 0.4
      },
      {
        "name": "Portugieser",
        "color": "red",
        "ha": 2.0,
        "pct": 0.4
      },
      {
        "name": "Zweigelt",
        "color": "red",
        "ha": 1.0,
        "pct": 0.2
      },
      {
        "name": "Cabernet Cortis",
        "color": "red",
        "ha": 1.0,
        "pct": 0.2
      },
      {
        "name": "Dunkelfelder",
        "color": "red",
        "ha": 1.0,
        "pct": 0.2
      }
    ]
  },
  "Ahr": {
    "totalHa": 531.0,
    "year": 2023,
    "notes": null,
    "bereiche": [
      {
        "name": "Walporzheim/Ahrtal",
        "ha": 531.0
      }
    ],
    "varieties": [
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 342.0,
        "pct": 64.4
      },
      {
        "name": "Riesling",
        "color": "white",
        "ha": 46.0,
        "pct": 8.7
      },
      {
        "name": "Frühburgunder",
        "color": "red",
        "ha": 31.0,
        "pct": 5.8
      },
      {
        "name": "Sonstige (rot)",
        "color": "red",
        "ha": 22.0,
        "pct": 4.1
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 22.0,
        "pct": 4.1
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 15.0,
        "pct": 2.8
      },
      {
        "name": "Regent",
        "color": "red",
        "ha": 15.0,
        "pct": 2.8
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 14.0,
        "pct": 2.6
      },
      {
        "name": "Portugieser",
        "color": "red",
        "ha": 12.0,
        "pct": 2.3
      },
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 12.0,
        "pct": 2.3
      }
    ]
  },
  "Baden": {
    "totalHa": 15456.0,
    "year": 2024,
    "notes": null,
    "bereiche": [
      {
        "name": "Kaiserstuhl",
        "ha": 4163.0
      },
      {
        "name": "Markgräflerland",
        "ha": 3273.0
      },
      {
        "name": "Ortenau",
        "ha": 2593.0
      },
      {
        "name": "Breisgau",
        "ha": 1544.0
      },
      {
        "name": "Kraichgau",
        "ha": 1174.0
      },
      {
        "name": "Tuniberg",
        "ha": 1051.0
      },
      {
        "name": "Bodensee",
        "ha": 668.0
      },
      {
        "name": "Tauberfranken",
        "ha": 609.0
      },
      {
        "name": "Badische Bergstraße",
        "ha": 381.0
      }
    ],
    "varieties": [
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 4910.0,
        "pct": 31.8
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 2390.0,
        "pct": 15.5
      },
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 2081.0,
        "pct": 13.5
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 1655.0,
        "pct": 10.7
      },
      {
        "name": "Gutedel",
        "color": "white",
        "ha": 999.0,
        "pct": 6.5
      },
      {
        "name": "Riesling",
        "color": "white",
        "ha": 835.0,
        "pct": 5.4
      },
      {
        "name": "Schwarzriesling",
        "color": "red",
        "ha": 194.0,
        "pct": 1.3
      },
      {
        "name": "Lemberger",
        "color": "red",
        "ha": 74.0,
        "pct": 0.5
      },
      {
        "name": "Kerner",
        "color": "white",
        "ha": 36.0,
        "pct": 0.2
      },
      {
        "name": "Trollinger",
        "color": "red",
        "ha": 21.0,
        "pct": 0.1
      }
    ]
  },
  "Mittelrhein": {
    "totalHa": 439.0,
    "year": 2023,
    "notes": null,
    "bereiche": [
      {
        "name": "Loreley",
        "ha": 439.0
      }
    ],
    "varieties": [
      {
        "name": "Riesling",
        "color": "white",
        "ha": 284.0,
        "pct": 64.7
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 48.0,
        "pct": 10.9
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 29.0,
        "pct": 6.6
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 23.0,
        "pct": 5.2
      },
      {
        "name": "Sonstige (rot)",
        "color": "red",
        "ha": 21.0,
        "pct": 4.8
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 18.0,
        "pct": 4.1
      },
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 16.0,
        "pct": 3.6
      }
    ]
  },
  "Mosel": {
    "totalHa": 8523.0,
    "year": 2023,
    "notes": null,
    "bereiche": [
      {
        "name": "Bernkastel",
        "ha": 5582.0
      },
      {
        "name": "Burg Cochem",
        "ha": 1110.0
      },
      {
        "name": "Saar",
        "ha": 793.0
      },
      {
        "name": "Obermosel",
        "ha": 742.0
      },
      {
        "name": "Ruwer",
        "ha": 180.0
      },
      {
        "name": "Moseltor",
        "ha": 116.0
      }
    ],
    "varieties": [
      {
        "name": "Riesling",
        "color": "white",
        "ha": 5330.0,
        "pct": 62.5
      },
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 742.0,
        "pct": 8.7
      },
      {
        "name": "Elbling",
        "color": "white",
        "ha": 440.0,
        "pct": 5.2
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 427.0,
        "pct": 5.0
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 364.0,
        "pct": 4.3
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 239.0,
        "pct": 2.8
      },
      {
        "name": "Dornfelder",
        "color": "red",
        "ha": 233.0,
        "pct": 2.7
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 211.0,
        "pct": 2.5
      },
      {
        "name": "Kerner",
        "color": "white",
        "ha": 140.0,
        "pct": 1.6
      },
      {
        "name": "Sonstige (rot)",
        "color": "red",
        "ha": 100.0,
        "pct": 1.2
      },
      {
        "name": "Chardonnay",
        "color": "white",
        "ha": 90.0,
        "pct": 1.1
      },
      {
        "name": "Bacchus",
        "color": "white",
        "ha": 41.0,
        "pct": 0.5
      },
      {
        "name": "Regent",
        "color": "red",
        "ha": 42.0,
        "pct": 0.5
      },
      {
        "name": "Sauvignon blanc",
        "color": "white",
        "ha": 35.0,
        "pct": 0.4
      },
      {
        "name": "Auxerrois",
        "color": "white",
        "ha": 38.0,
        "pct": 0.4
      },
      {
        "name": "Gewürztraminer",
        "color": "white",
        "ha": 15.0,
        "pct": 0.2
      },
      {
        "name": "Souvignier gris",
        "color": "white",
        "ha": 13.0,
        "pct": 0.2
      },
      {
        "name": "Sonstige",
        "color": null,
        "ha": 13.0,
        "pct": 0.2
      },
      {
        "name": "Roter Riesling",
        "color": "white",
        "ha": 12.0,
        "pct": 0.1
      }
    ]
  },
  "Nahe": {
    "totalHa": 4250.0,
    "year": 2023,
    "notes": null,
    "bereiche": [
      {
        "name": "Nahetal",
        "ha": 4250.0
      }
    ],
    "varieties": [
      {
        "name": "Riesling",
        "color": "white",
        "ha": 1244.0,
        "pct": 29.3
      },
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 469.0,
        "pct": 11.0
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 396.0,
        "pct": 9.3
      },
      {
        "name": "Dornfelder",
        "color": "red",
        "ha": 377.0,
        "pct": 8.9
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 333.0,
        "pct": 7.8
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 299.0,
        "pct": 7.0
      },
      {
        "name": "Silvaner",
        "color": "white",
        "ha": 177.0,
        "pct": 4.2
      },
      {
        "name": "Bacchus",
        "color": "white",
        "ha": 120.0,
        "pct": 2.8
      },
      {
        "name": "Kerner",
        "color": "white",
        "ha": 105.0,
        "pct": 2.5
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 105.0,
        "pct": 2.5
      },
      {
        "name": "Scheurebe",
        "color": "white",
        "ha": 101.0,
        "pct": 2.4
      },
      {
        "name": "Regent",
        "color": "red",
        "ha": 88.0,
        "pct": 2.1
      },
      {
        "name": "Chardonnay",
        "color": "white",
        "ha": 75.0,
        "pct": 1.8
      },
      {
        "name": "Portugieser",
        "color": "red",
        "ha": 69.0,
        "pct": 1.6
      },
      {
        "name": "Sauvignon blanc",
        "color": "white",
        "ha": 60.0,
        "pct": 1.4
      },
      {
        "name": "Sonstige (rot)",
        "color": "red",
        "ha": 53.0,
        "pct": 1.2
      },
      {
        "name": "Gewürztraminer",
        "color": "white",
        "ha": 30.0,
        "pct": 0.7
      },
      {
        "name": "Merlot",
        "color": "red",
        "ha": 27.0,
        "pct": 0.6
      },
      {
        "name": "Saint Laurent",
        "color": "red",
        "ha": 20.0,
        "pct": 0.5
      },
      {
        "name": "Muskateller",
        "color": "white",
        "ha": 17.0,
        "pct": 0.4
      },
      {
        "name": "Würzer",
        "color": "white",
        "ha": 17.0,
        "pct": 0.4
      },
      {
        "name": "Frühburgunder",
        "color": "red",
        "ha": 18.0,
        "pct": 0.4
      },
      {
        "name": "Cabernet Sauvignon",
        "color": "red",
        "ha": 16.0,
        "pct": 0.4
      },
      {
        "name": "Dunkelfelder",
        "color": "red",
        "ha": 15.0,
        "pct": 0.4
      },
      {
        "name": "Faberrebe",
        "color": "white",
        "ha": 11.0,
        "pct": 0.3
      },
      {
        "name": "Phoenix",
        "color": "white",
        "ha": 10.0,
        "pct": 0.2
      }
    ]
  },
  "Pfalz": {
    "totalHa": 23793.0,
    "year": 2023,
    "notes": null,
    "bereiche": [
      {
        "name": "Südliche Weinstraße",
        "ha": 12733.0
      },
      {
        "name": "Mittelhaardt/Deutsche Weinstraße",
        "ha": 11060.0
      }
    ],
    "varieties": [
      {
        "name": "Riesling",
        "color": "white",
        "ha": 5954.0,
        "pct": 25.0
      },
      {
        "name": "Dornfelder",
        "color": "red",
        "ha": 2453.0,
        "pct": 10.3
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 2235.0,
        "pct": 9.4
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 1739.0,
        "pct": 7.3
      },
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 1590.0,
        "pct": 6.7
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 1491.0,
        "pct": 6.3
      },
      {
        "name": "Portugieser",
        "color": "red",
        "ha": 1039.0,
        "pct": 4.4
      },
      {
        "name": "Chardonnay",
        "color": "white",
        "ha": 969.0,
        "pct": 4.1
      },
      {
        "name": "Sauvignon blanc",
        "color": "white",
        "ha": 794.0,
        "pct": 3.3
      },
      {
        "name": "Kerner",
        "color": "white",
        "ha": 584.0,
        "pct": 2.5
      },
      {
        "name": "Gewürztraminer",
        "color": "white",
        "ha": 508.0,
        "pct": 2.1
      },
      {
        "name": "Silvaner",
        "color": "white",
        "ha": 449.0,
        "pct": 1.9
      },
      {
        "name": "Regent",
        "color": "red",
        "ha": 455.0,
        "pct": 1.9
      },
      {
        "name": "Merlot",
        "color": "red",
        "ha": 429.0,
        "pct": 1.8
      },
      {
        "name": "Scheurebe",
        "color": "white",
        "ha": 328.0,
        "pct": 1.4
      },
      {
        "name": "Cabernet Sauvignon",
        "color": "red",
        "ha": 257.0,
        "pct": 1.1
      },
      {
        "name": "Saint Laurent",
        "color": "red",
        "ha": 255.0,
        "pct": 1.1
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 180.0,
        "pct": 0.8
      },
      {
        "name": "Muskateller",
        "color": "white",
        "ha": 186.0,
        "pct": 0.8
      },
      {
        "name": "Morio-Muskat",
        "color": "white",
        "ha": 161.0,
        "pct": 0.7
      },
      {
        "name": "Sonstige (rot)",
        "color": "red",
        "ha": 147.0,
        "pct": 0.6
      },
      {
        "name": "Cabernet blanc",
        "color": "white",
        "ha": 146.0,
        "pct": 0.6
      },
      {
        "name": "Ortega",
        "color": "white",
        "ha": 132.0,
        "pct": 0.6
      },
      {
        "name": "Schwarzriesling",
        "color": "red",
        "ha": 123.0,
        "pct": 0.5
      },
      {
        "name": "Cabernet Dorsa",
        "color": "red",
        "ha": 91.0,
        "pct": 0.4
      },
      {
        "name": "Acolon",
        "color": "red",
        "ha": 95.0,
        "pct": 0.4
      },
      {
        "name": "Auxerrois",
        "color": "white",
        "ha": 91.0,
        "pct": 0.4
      },
      {
        "name": "Bacchus",
        "color": "white",
        "ha": 84.0,
        "pct": 0.4
      },
      {
        "name": "Dunkelfelder",
        "color": "red",
        "ha": 96.0,
        "pct": 0.4
      },
      {
        "name": "Huxelrebe",
        "color": "white",
        "ha": 86.0,
        "pct": 0.4
      },
      {
        "name": "Cabernet Franc",
        "color": "red",
        "ha": 64.0,
        "pct": 0.3
      },
      {
        "name": "Syrah",
        "color": "red",
        "ha": 71.0,
        "pct": 0.3
      },
      {
        "name": "Cabernet Mitos",
        "color": "red",
        "ha": 66.0,
        "pct": 0.3
      },
      {
        "name": "Sauvignac",
        "color": "white",
        "ha": 62.0,
        "pct": 0.3
      },
      {
        "name": "Heroldrebe",
        "color": "red",
        "ha": 55.0,
        "pct": 0.2
      },
      {
        "name": "Souvignier gris",
        "color": "white",
        "ha": 45.0,
        "pct": 0.2
      },
      {
        "name": "Goldmuskateller",
        "color": "white",
        "ha": 40.0,
        "pct": 0.2
      },
      {
        "name": "Solaris",
        "color": "white",
        "ha": 44.0,
        "pct": 0.2
      },
      {
        "name": "Frühburgunder",
        "color": "red",
        "ha": 46.0,
        "pct": 0.2
      },
      {
        "name": "Lemberger",
        "color": "red",
        "ha": 31.0,
        "pct": 0.1
      },
      {
        "name": "Cabernet Cubin",
        "color": "red",
        "ha": 20.0,
        "pct": 0.1
      },
      {
        "name": "Rieslaner",
        "color": "white",
        "ha": 30.0,
        "pct": 0.1
      },
      {
        "name": "Grüner Veltliner",
        "color": "white",
        "ha": 14.0,
        "pct": 0.1
      },
      {
        "name": "Muscaris",
        "color": "white",
        "ha": 22.0,
        "pct": 0.1
      },
      {
        "name": "Siegerrebe",
        "color": "white",
        "ha": 18.0,
        "pct": 0.1
      },
      {
        "name": "Calardis blanc",
        "color": "white",
        "ha": 12.0,
        "pct": 0.1
      }
    ]
  },
  "Rheingau": {
    "totalHa": 3157.0,
    "year": 2023,
    "notes": null,
    "bereiche": [
      {
        "name": "Johannisberg",
        "ha": 3157.0
      }
    ],
    "varieties": [
      {
        "name": "Riesling",
        "color": "white",
        "ha": 2402.0,
        "pct": 76.1
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 398.0,
        "pct": 12.6
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 294.0,
        "pct": 9.3
      },
      {
        "name": "Sonstige (rot)",
        "color": "red",
        "ha": 63.0,
        "pct": 2.0
      }
    ]
  },
  "Rheinhessen": {
    "totalHa": 27499.0,
    "year": 2023,
    "notes": null,
    "bereiche": [
      {
        "name": "Nierstein",
        "ha": 10460.0
      },
      {
        "name": "Bingen",
        "ha": 8928.0
      },
      {
        "name": "Wonnegau",
        "ha": 8111.0
      }
    ],
    "varieties": [
      {
        "name": "Riesling",
        "color": "white",
        "ha": 5383.0,
        "pct": 19.6
      },
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 3834.0,
        "pct": 13.9
      },
      {
        "name": "Dornfelder",
        "color": "red",
        "ha": 3022.0,
        "pct": 11.0
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 2424.0,
        "pct": 8.8
      },
      {
        "name": "Silvaner",
        "color": "white",
        "ha": 1876.0,
        "pct": 6.8
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 1640.0,
        "pct": 6.0
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 1505.0,
        "pct": 5.5
      },
      {
        "name": "Chardonnay",
        "color": "white",
        "ha": 1087.0,
        "pct": 4.0
      },
      {
        "name": "Portugieser",
        "color": "red",
        "ha": 885.0,
        "pct": 3.2
      },
      {
        "name": "Scheurebe",
        "color": "white",
        "ha": 743.0,
        "pct": 2.7
      },
      {
        "name": "Sauvignon blanc",
        "color": "white",
        "ha": 649.0,
        "pct": 2.4
      },
      {
        "name": "Kerner",
        "color": "white",
        "ha": 574.0,
        "pct": 2.1
      },
      {
        "name": "Regent",
        "color": "red",
        "ha": 553.0,
        "pct": 2.0
      },
      {
        "name": "Bacchus",
        "color": "white",
        "ha": 413.0,
        "pct": 1.5
      },
      {
        "name": "Sonstige (weiß)",
        "color": "white",
        "ha": 317.0,
        "pct": 1.2
      },
      {
        "name": "Merlot",
        "color": "red",
        "ha": 247.0,
        "pct": 0.9
      },
      {
        "name": "Saint Laurent",
        "color": "red",
        "ha": 247.0,
        "pct": 0.9
      },
      {
        "name": "Gewürztraminer",
        "color": "white",
        "ha": 233.0,
        "pct": 0.8
      },
      {
        "name": "Huxelrebe",
        "color": "white",
        "ha": 224.0,
        "pct": 0.8
      },
      {
        "name": "Sonstige (rot)",
        "color": "red",
        "ha": 196.0,
        "pct": 0.7
      },
      {
        "name": "Faberrebe",
        "color": "white",
        "ha": 159.0,
        "pct": 0.6
      },
      {
        "name": "Ortega",
        "color": "white",
        "ha": 172.0,
        "pct": 0.6
      },
      {
        "name": "Cabernet Sauvignon",
        "color": "red",
        "ha": 132.0,
        "pct": 0.5
      },
      {
        "name": "Morio-Muskat",
        "color": "white",
        "ha": 138.0,
        "pct": 0.5
      },
      {
        "name": "Muskateller",
        "color": "white",
        "ha": 108.0,
        "pct": 0.4
      },
      {
        "name": "Frühburgunder",
        "color": "red",
        "ha": 73.0,
        "pct": 0.3
      },
      {
        "name": "Souvignier gris",
        "color": "white",
        "ha": 96.0,
        "pct": 0.3
      },
      {
        "name": "Schwarzriesling",
        "color": "red",
        "ha": 77.0,
        "pct": 0.3
      },
      {
        "name": "Solaris",
        "color": "white",
        "ha": 57.0,
        "pct": 0.2
      },
      {
        "name": "Cabernet blanc",
        "color": "white",
        "ha": 61.0,
        "pct": 0.2
      },
      {
        "name": "Johanniter",
        "color": "white",
        "ha": 47.0,
        "pct": 0.2
      },
      {
        "name": "Acolon",
        "color": "red",
        "ha": 47.0,
        "pct": 0.2
      },
      {
        "name": "Cabernet Dorsa",
        "color": "red",
        "ha": 51.0,
        "pct": 0.2
      },
      {
        "name": "Cabernet Mitos",
        "color": "red",
        "ha": 55.0,
        "pct": 0.2
      },
      {
        "name": "Muscaris",
        "color": "white",
        "ha": 35.0,
        "pct": 0.1
      },
      {
        "name": "Sauvignac",
        "color": "white",
        "ha": 22.0,
        "pct": 0.1
      },
      {
        "name": "Dunkelfelder",
        "color": "red",
        "ha": 22.0,
        "pct": 0.1
      },
      {
        "name": "Auxerrois",
        "color": "white",
        "ha": 18.0,
        "pct": 0.1
      },
      {
        "name": "Goldmuskateller",
        "color": "white",
        "ha": 26.0,
        "pct": 0.1
      },
      {
        "name": "Lemberger",
        "color": "red",
        "ha": 15.0,
        "pct": 0.1
      },
      {
        "name": "Siegerrebe",
        "color": "white",
        "ha": 17.0,
        "pct": 0.1
      },
      {
        "name": "Würzer",
        "color": "white",
        "ha": 11.0,
        "pct": 0.0
      },
      {
        "name": "Phoenix",
        "color": "white",
        "ha": 10.0,
        "pct": 0.0
      }
    ]
  },
  "Württemberg": {
    "totalHa": 11164.8,
    "year": 2025,
    "notes": null,
    "bereiche": [
      {
        "name": "Württembergisch Unterland",
        "ha": 8906.0
      },
      {
        "name": "Remstal",
        "ha": 1758.0
      },
      {
        "name": "Kocher-Jagst-Tauber",
        "ha": 375.0
      },
      {
        "name": "Württembergischer Bodensee",
        "ha": 66.1
      },
      {
        "name": "Neckar-Alb",
        "ha": 47.1
      },
      {
        "name": "Bayerischer Bodensee",
        "ha": 12.6
      }
    ],
    "varieties": [
      {
        "name": "Riesling",
        "color": "white",
        "ha": 2081.0,
        "pct": 18.6
      },
      {
        "name": "Trollinger",
        "color": "red",
        "ha": 1901.0,
        "pct": 17.0
      },
      {
        "name": "Lemberger",
        "color": "red",
        "ha": 1727.0,
        "pct": 15.5
      },
      {
        "name": "Schwarzriesling",
        "color": "red",
        "ha": 1116.0,
        "pct": 10.0
      },
      {
        "name": "Spätburgunder",
        "color": "red",
        "ha": 858.0,
        "pct": 7.7
      },
      {
        "name": "Grauburgunder",
        "color": "white",
        "ha": 324.0,
        "pct": 2.9
      },
      {
        "name": "Müller-Thurgau",
        "color": "white",
        "ha": 265.0,
        "pct": 2.4
      },
      {
        "name": "Weißburgunder",
        "color": "white",
        "ha": 255.0,
        "pct": 2.3
      },
      {
        "name": "Kerner",
        "color": "white",
        "ha": 243.0,
        "pct": 2.2
      }
    ]
  }
};
